import React from 'react'
import { RounderUtil } from 'utils'

import { Form, Col } from '_zari/core'

const MontoPercepcionFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, vTotal, handleChange, iValue }) => {

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      const valorStr = e.target.value
      const valorNumero = parseFloat(valorStr || '0')

      const total = RounderUtil.round(vTotal - iValue + valorNumero)
      setFieldValue('importeTotal', total)
    },
    [setFieldValue, vTotal, handleChange, iValue]
  )

  return (
    <Form.Group>
      <Form.Label text='PERCEPCION' htmlFor='number-montoPercepcion' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber name='montoPercepcion'  id='number-montoPercepcion' disabled={fIsSubmitting} isInvalid={iTouched && iError} value={iValue} onChange={onChange} />
        {/* <Field name='montoPercepcion'>
          {({ field }) => <Form.InputNumber {...field} id='number-montoPercepcion' disabled={fIsSubmitting} isInvalid={iTouched && iError} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null} */}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoPercepcionFormGroup)
